import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import swal from 'sweetalert2';
import { ErrorHandler } from '../../../shared/ErrorHandler';
import { UserService } from '../../../shared/user.service';


@Component({
  selector: 'app-claim-form',
  templateUrl: './claim-form.component.html',
  styleUrls: ['./claim-form.component.css']
})
export class ClaimFormComponent implements OnInit {
  title = "Claims";
  roleId: string;
  roleName: string;
  officeName: string;
  claimsList: any;
  data: any;

  constructor(private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler, private userService: UserService) { }

  ngOnInit() {    
    this.route.params.subscribe(params => {
      this.roleId = params['roleId']
      this.roleName = params['roleName']
    });
    if (this.roleId != null && this.roleName != null)
      this.GetAllClaimsForTheRole(this.roleId);
  }

  // GetAllClaimsForTheRole(roleId) {
  //   debugger
  //   document.getElementById('loader-spinner').style.display = "block";
  //   this.userService.getAllClaimsForTheRole(roleId)
  //     .subscribe((data) => {
  //       this.claimsList=data;
  //       // if(this.claimsList.length!=0){
  //       // this.claimsList= data;
      
  //       document.getElementById('loader-spinner').style.display = "none";
  //     }, (error) => {
  //       document.getElementById('loader-spinner').style.display = "none";
  //       this.errorHandler.HandlerError(error);
  //     });  
  //   alert(this.data);
  // }
  // GetAllClaimsForTheRole(roleId) {
  //   debugger;
  //   document.getElementById('loader-spinner').style.display="block";
  //   this.userService.getAllClaimsForTheRole(roleId)
  //     .subscribe(
  //       (data:any) => {
  //         if(data.RoleClaimsModels.length!=undefined)
  //         {
  //         this.claimsList = data;
  //         }
  //         document.getElementById('loader-spinner').style.display="none";
  //       }, (error) => {
  //         document.getElementById('loader-spinner').style.display="none";
  //         this.errorHandler.HandlerError(error);
  //       });
  //       alert(this.claimsList)
  // }
  
  GetAllClaimsForTheRole(roleId){
    debugger;
    this.userService.getAllClaimsForTheRole(roleId).subscribe(data =>{
      this.claimsList = data;
      console.log(this.claimsList);
    })
  }

  SaveClaims(claimsList) {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.saveClaims(claimsList, this.roleId)
    this.data.subscribe(
      (response) => {

        swal('', 'Success! Note: This changes will come into effect when the user log out and log in again.', 'success');
        this.router.navigate(['/home/claims']);
        document.getElementById('loader-spinner').style.display = "none";

      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 401)

          this.errorHandler.HandlerError(error);
      });
  }

  changeCheckbox(menuPos, pagePos, claimPos) {
    debugger;
    for (let i = 0; i < this.claimsList.length; i++) {
      if (i == menuPos) {
        for (let j = 0; j < this.claimsList[i].PagesList.length; j++) {
          if (j == pagePos) {
            for (let k = 0; k < this.claimsList[i].PagesList[j].PageFunctionClaim.length; k++) {
              if (k == claimPos) {
                let val: boolean = null;
                if (this.claimsList[i].PagesList[j].PageFunctionClaim[k].ClaimValue == true)
                  val = false;
                else
                  val = true;
                this.claimsList[i].PagesList[j].PageFunctionClaim[k].ClaimValue = val;
              }
            }
          }
        }
      }
    }
  }

}


// WEBPACK FOOTER //
// ./src/app/ultilities/claims/claim-form/claim-form.component.ts